import { render, staticRenderFns } from "./ValidacionAsuntosInternosDialogComponent.vue?vue&type=template&id=43dcadb3"
import script from "./ValidacionAsuntosInternosDialogComponent.vue?vue&type=script&lang=js"
export * from "./ValidacionAsuntosInternosDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports